import { AuthenticateTokenComponent } from "./authenticate-token.component";
export const AuthenticateTokenModule = angular
    .module('authenticateToken', [])
    .component(AuthenticateTokenComponent.selector, AuthenticateTokenComponent.component)
    .name;
//# sourceMappingURL=authenticate-token.module.js.map